/**
 * v-tableScrollTop
 * control table body scroll to top when page & sort & fiter change
 *
 * @param {*} app
 */
export function registerTableScrollTop(app) {
  const Vue = app.context._vue
  Vue.directive('tableScrollTop', {
    // 当被绑定的元素插入到 DOM 中时
    inserted: function (_el, _binding, vnode) {
      const updateScrollY = vnode.componentInstance.updateScrollY
      vnode.componentInstance.updateScrollY = function () {
        vnode.componentInstance.bodyWrapper.scrollTop = 0
        updateScrollY.call(vnode.componentInstance)
      }
    }
  })
}
